import axios from 'axios'
import { msalInstance } from '../auth/msalInstance'
import { loginRequest, apiConfig } from '../auth/msalConfig'

const IS_MOCK = import.meta.env.VITE_MOCK_AUTH === 'true'

const apiClient = axios.create({
  baseURL: apiConfig.baseUrl,
  headers: { 'Content-Type': 'application/json' },
})

// Interceptor — v mock módu nepotřebujeme token, backend mock auth ho nevyžaduje
apiClient.interceptors.request.use(async (config) => {
  if (IS_MOCK) return config

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      config.headers.Authorization = `Bearer ${response.accessToken}`
    } catch {
      // Silent token acquisition failed — pokus o interaktivní login
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...loginRequest,
          account: accounts[0],
        })
        config.headers.Authorization = `Bearer ${response.accessToken}`
      } catch {
        // Popup selhal (zablokován nebo uzavřen) — request pokračuje bez tokenu → API vrátí 401
      }
    }
  }
  return config
})

export default apiClient
